import { Provider } from 'urql'

import { createUrqlClient } from 'urql-utils/src/createUrqlClient'

import { correlationId } from './correlationId'

const isLocalDev = process.env.NODE_ENV !== 'production'
const url = process.env.NEXT_PUBLIC_GRAPHQL_API_URL
const LOCAL_DEV_GRAPHQL_API_KEY =
  process.env.NEXT_PUBLIC_LOCAL_DEV_GRAPHQL_API_KEY
const SERVER_GRAPHQL_API_KEY = process.env.SERVER_GRAPHQL_API_KEY

export const client = createUrqlClient({
  options: {
    url,
    fetchOptions: {
      headers: {
        'x-graphql-client-name': 'bluelagoon',
        ...(isLocalDev && {
          'x-local-dev-graphql-api-key': LOCAL_DEV_GRAPHQL_API_KEY,
        }),
      },
    },
  },
  correlationId,
})

export const serverSideClient = createUrqlClient({
  options: {
    url,
    fetchOptions: {
      headers: {
        'x-graphql-client-name': 'bluelagoon-server',
        'x-server-graphql-api-key': SERVER_GRAPHQL_API_KEY,
      },
    },
  },
  correlationId,
  isServer: true,
})

export const UrqlClientProvider = ({ children }) => {
  return <Provider value={client}>{children}</Provider>
}
